import { http } from '@/utils'

/**
 * 获取个人薪资信息
 */
export const querySalaryInfo = (params?: any) => {
  return http.get('/salary/personal', { params })
}

/**
 * 获取个人薪资信息
 */
export const queryPersonalSalaryList = (data?: any) => {
  return http.post(`/salary/base/fixed/person/salarys`, data)
}

/**
 * 获取个人薪资信息
 */
export const queryPersonalInfo = (id: string) => {
  return http.get(`/hrm/employee/${id}`)
}

/**
 * 保存个人薪资信息
 */
export const savePersonalSalary = (data: any) => {
  return http.post('/salary/base/setting/salary', data)
}

/**
 * 获取定薪预览
 */
export const querySalarySetPreview = (data: any) => {
  return http.post('/salary/base/setting/salarys', data)
}

/**
 * 获取调薪记录
 */
export const querySalaryRecords = (data: any) => {
  return http.post('/salary/base/fixed/salary/records', data)
}

/**
 * 删除调薪记录
 */
export const deleteSalaryRecord = (data: any) => {
  return http.delete('/salary/base/fixed/salary', { data })
}

/**
 * 撤销调薪记录
 */
export const revokeSalaryRecord = (id: string) => {
  return http.post(`/salary/base/fixed/salary/${id}`)
}

/**
 * 调薪
 */
export const saveSalaryAdjust = (data: any) => {
  return http.post('/salary/base/fixed/salary', data)
}

/**
 * 获取调薪预览
 */
export const querySalaryAdjustPreview = (data: any) => {
  return http.post('/salary/base/fixed/salarys', data)
}

// 获取字典 - 员工异动数据源
export const getYidongDict = (): IResponseType<any> =>
  http.request({
    url: '/hrm/movement/field',
    method: 'get',
    params: { flow_dic: 0 }
  })

// 修改薪酬方案
export const updateSalaryScheme = (data: any): IResponseType<any> => {
  return http.put(`/hrm/employee/field`, data)
}
